import { GetEmail as UsecaseReduxGetEmail } from '~/domain/usecases/users/redux';
import { ReduxGetEmail } from '~/data/store/reducer/users/usecases';

/**
 * send request via REDUX.
 */
export const makeReduxGetAllUsers = (): UsecaseReduxGetEmail =>
  new ReduxGetEmail();
